// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__kq83X","buttons":"SendReceipts_buttons__34VDr","email":"SendReceipts_email__2PglJ","bookApptTitle":"SendReceipts_bookApptTitle__3Rlm4"};